import { render, staticRenderFns } from "./ImportFormsStyleModal.vue?vue&type=template&id=2a601e2f"
import script from "./ImportFormsStyleModal.vue?vue&type=script&lang=js"
export * from "./ImportFormsStyleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports